<template>
  <div class="ddlb-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm">
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="searchForm.state" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="待接单" :value="2" />
                <el-option label="售后处理" :value="3" />
                <el-option label="技术评估" :value="4" />
                <el-option label="拆单分配" :value="5" />
                <el-option label="拆单" :value="6" />
                <el-option label="审单" :value="88" />
                <el-option label="订单确认" :value="7" />
                <el-option label="待报价" :value="8" />
                <el-option label="预付款" :value="9" />
                <el-option label="工厂分派" :value="10" />
                <el-option label="生产接单" :value="11" />
                <el-option label="订单排产" :value="12" />
                <el-option label="订单生产" :value="13" />
                <el-option label="已取消" :value="99" />
                <el-option label="已完成" :value="100" />
              </el-select>
            </el-form-item>
            <el-form-item label="操作时间">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <!--<el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>-->
            <el-form-item label="搜索关键字1">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item label="搜索关键字2">
              <el-input v-model="searchForm.search2" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item label="搜索关键字3">
              <el-input v-model="searchForm.search3" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item label="搜索关键字4">
              <el-input v-model="searchForm.search4" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
              <el-button icon="el-icon-document-copy" @click="exportDialogVisible = true">其他导出</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
                      <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="delname"
                    label="经销商"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.delname && scope.row.delname.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.delname }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.type===0">正单</span>
                      <span v-if="scope.row.type===1">客改单</span>
                      <span v-if="scope.row.type===2">增补单</span>
                      <span v-if="scope.row.type===3">色板单</span>
                      <span v-if="scope.row.type===4">售后单</span>
                    </template>
                  </el-table-column>
                  <!--<el-table-column
                    label="品牌"
                    width="130"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">品牌：</span>
                      <span>{{scope.row.brandname}}</span>
                    </template>
                  </el-table-column>-->
                  <el-table-column
                    prop="time"
                    label="上次操作时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="拆单人员"
                    align="center"
                    width="120">
                    <template slot-scope="scope">
                      <span v-if="scope.row.splitName!==''&&scope.row.splitName!==null">{{ scope.row.splitName }}</span>
                      <span v-if="scope.row.splitName===''||scope.row.splitName===null" style="color: #99a9bf;">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆单完成/预计完成时间"
                    :width="170"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.preSplit" style="display: flex; flex-direction: column; align-items: center;">
                        <span>{{ scope.row.preSplit }}</span>
                        <span v-if="scope.row.preHours"
                          style="color: #F56C6C; font-weight: bold;"
                          :style="scope.row.preHours.indexOf('还剩0天') > -1 ? 'color: #E6A23C;' : (scope.row.preHours.indexOf('还剩') > -1 ? 'color: #67C23A;' : '')">
                          {{ scope.row.preHours }}
                        </span>
                      </div>
                      <span v-else style="color:#999999;">--</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="plannedAdd"
                    align="center"
                    label="计划交期"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="核对情况"
                    width="80"
                    fixed="right"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.chk==0" :disable-transitions="true" size="mini" type="warning">未核对</el-tag>
                      <el-tag v-if="scope.row.chk==1" :disable-transitions="true" size="mini">已核对</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="当前状态"
                    fixed="right"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===2" type="danger">售后驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===3" type="danger">评估驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===4" type="danger">确认驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===5" type="danger">报价驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===6" type="danger">预付驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===7" type="danger">工厂拒接</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===8" type="danger">审单驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2&&scope.row.dismark===0" type="warning">待接单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===3" class="tcf-tag-1">售后处理</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4" class="tcf-tag-5">技术评估</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===5" class="tcf-tag-4">拆单分配</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===6&&scope.row.dismark===0" class="tcf-tag-2">待拆单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===7&&scope.row.dismark===0" class="tcf-tag-6">订单确认</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===8&&scope.row.dismark===0" class="tcf-tag-3">待报价</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===9&&scope.row.dismark===0" class="tcf-tag-9">预付款</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===10&&scope.row.dismark===0" class="tcf-tag-7">工厂分派</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===11" class="tcf-tag-8">工厂接单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===12" class="tcf-tag-10">订单排产</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===13" class="tcf-tag-11">订单生产</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===88" class="tcf-tag-1">待审单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===99">已取消</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===100">已完成</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="100"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template>
                      <span style="font-size: 13px;color:#99a9bf">订单详情 <i class="el-icon-d-arrow-right"></i></span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="exportDialogVisible"
      title="其他导出"
      width="750px"
      top="10vh"
    >
      <el-tabs type="border-card">
        <el-tab-pane label="订单预警表">
          <div>
            <el-form :model="exportSearchForm" size="small" label-width="90px">
              <el-form-item label="组织">
                <el-select v-model="exportSearchForm.groupid" placeholder="请选择组织">
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="乔金斯" value="2"></el-option>
                  <el-option label="首造" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下单时间">
                <el-date-picker
                  v-model="exportSearchForm.times"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-printer" type="primary" :loading="excelLoading" @click="exportExcel_1">导出订单预警表</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getALLOrderList, exportOrderExcel } from '@/api/erp'
import { getBrandList } from '@/api/work'

import axios from 'axios'

export default {
  name: 'ddlb',
  computed: {
    user: getUser
  },
  data() {
    return {
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        search: '',
        search2: '',
        search3: '',
        search4: '',
        type: '',
        brandId: '',
        state: '',
        opertime: ''
      },
      brandList: [],

      exportDialogVisible: false,
      excelLoading: false,
      exportSearchForm: {
        groupid: '2'
      },
    }
  },
  created() {
    this.getData()
    this.getBrandList()
  },
  methods: {
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.searchForm.search2 = this.searchForm.search2.trim()
      this.searchForm.search3 = this.searchForm.search3.trim()
      this.searchForm.search4 = this.searchForm.search4.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
        startTime = this.searchForm.opertime[0]
        endTime = this.searchForm.opertime[1]
      }
      const data = {
        content: this.searchForm.search,
        content2: this.searchForm.search2,
        content3: this.searchForm.search3,
        content4: this.searchForm.search4,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId,
        state: this.searchForm.state,
        startTime: startTime,
        endTime: endTime
      }
      getALLOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    exportExcel() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
        startTime = this.searchForm.opertime[0]
        endTime = this.searchForm.opertime[1]
      }
      const data = {
        content: this.searchForm.search,
        content2: this.searchForm.search,
        content3: this.searchForm.search,
        content4: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId,
        state: this.searchForm.state,
        startTime: startTime,
        endTime: endTime
      }
      this.$message({
        message: '数据正在导出，请稍候'
      })
      exportOrderExcel(data).then(response => {
        const _this = this
        let xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      if (row.orderid.length > 36) {
        this.$router.push({
          path: '/work/order/' + row.orderid.substring(0, 36),
          query: {
            data: row.orderid.substring(37)
          }
        })
      } else {
        this.$router.push({ path: '/work/order/' + row.orderid.substring(0, 36) })
      }
    },

    openDiago() {

    },
    // 导出订单预警表
    exportExcel_1() {
      if (!this.excelLoading) {
        this.excelLoading = true
        const brand = this.exportSearchForm.groupid == 1 ? '首造' : '乔金斯'

        const times = this.exportSearchForm.times
        if (!times || times.length < 2) {
          this.$message({
            type: 'error',
            message: '请先选择下单时间'
          })
          return
        }
        const start = times && times ? times[0] : ''
        const end = times ? times[1] : ''

        const data = {
          start: start,
          end: end,
          groupid: this.exportSearchForm.groupid,
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        axios({
          method: 'post',
          url: process.env.VUE_APP_BASE_API + '/api/test',
          params: data,
          responseType: 'blob', // 表明返回服务器返回的数据类型
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => { // 处理返回的文件流
          this.excelLoading = false
          const blob = new Blob([res.data]);
          const fileName = start + ' ~ ' + end + ' ' + brand + '订单预警表.xlsx';
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(
            elink.href);
          document.body.removeChild(elink);
        }).catch(err => {
          this.excelLoading = false
          this.$message({
            type: 'error',
            message: '导出失败，请稍候再试'
          })
        });
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.ddlb-container {
  .tcf-tag-1{
    background: #E8EDF9;
    border-color: #D0DCF8;
    color: #5F8EFC;
  }
  .tcf-tag-2{
    background: #FCE9F6;
    border-color: #FCD5F0;
    color: #F95BC9;
  }
  .tcf-tag-3{
    background: #ECE3FC;
    border-color: #D6BFFF;
    color: #8D55F9;
  }
  .tcf-tag-4{
    background: #FFEEE6;
    border-color: #FFDECE;
    color: #FE7530;
  }
  .tcf-tag-5{
    background: #E8F5FF;
    border-color: #C7E7FF;
    color: #32A7FF;
  }
  .tcf-tag-6{
    background: #EEFCFE;
    border-color: #D6F7FC;
    color: #72B5C1;
  }
  .tcf-tag-7{
    background: #F9FBF0;
    border-color: #E3EBC1;
    color: #B1BF75;
  }
  .tcf-tag-8{
     background: #F9ECD7;
     border-color: #F4CF97;
     color: #C5892E;
   }
  .tcf-tag-9{
    background: #EEF1F7;
    border-color: #BBC7DA;
    color: #7A869A;
  }
  .tcf-tag-10{
    background: #E2F5F2;
    border-color: #CAF4ED;
    color: #419488;
  }
  .tcf-tag-11{
    background: #F5F7FE;
    border-color: #C4CBE1;
    color: #828EB7;
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
